import { MarketOverviewPages, MarketPredictPages, Page, Product, RetailPages } from '../common';

export const getPageBasedOnPath = (path: string, products: Product[] = []): Page | undefined => {
  let pages = [];

  switch (true) {
    case products.includes(Product.Market):
      pages = MarketPredictPages;
      break;
    case products.includes(Product.Retail):
      pages = RetailPages;
      break;
    case products.includes(Product.Market4x):
      pages = MarketOverviewPages;
      break;
    case products.includes(Product.Market6x):
      pages = MarketOverviewPages;
      break;
    default:
      pages = MarketOverviewPages;
      break;
  }

  return pages.find(item => {
    if (item.match) {
      return item.match.test(path);
    }
    if (Array.isArray(item.path)) {
      return item.path.includes(path);
    }
    return item.path === path;
  });
};
